import React from "react";
import styled from "styled-components";
import { gql } from "apollo-boost";
import { withRouter, Switch, Route } from "react-router-dom";
import { graphql, compose } from "react-apollo";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverContentItem
} from "../Popover";
import * as colors from "../../settings/colors";
import Icon from "../Icon";
import { CODE } from "../../icons";

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  margin-top: -12px;
  right: 20px;
  transform-origin: 50%;
  transform: rotate(90deg);
  color: ${colors.SIDEBAR_TEXT};
`;

const StyledPopoverTrigger = PopoverTrigger.extend`
  position: relative;
  display: block;
  text-align: left;
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
  padding: 18px 20px;

  &:before {
    display: block;
    position: absolute;
    content: "";
    top: 0;
    left: 12px;
    right: 12px;
    height: 1px;
    background: ${colors.SIDEBAR_DIVIDER};
  }

  &:hover {
    background: ${colors.SIDEBAR_DIVIDER};
  }

  &:not([aria-disabled="true"]):focus {
    box-shadow: none;
  }
`;

const SwitcherLabel = styled.span`
  display: block;
  color: ${colors.SIDEBAR_TEXT};
  font-size: 12px;
`;

const AccountSwitcher = ({ history, userData, franchiseData }) => {
  if (userData.loading) return null;
  if (userData.error) return null;

  const hasAdminAccess = userData.currentUser.role !== "franchisee";

  const handleSelection = (value, e) => {
    if (e) e.preventDefault();
    history.push(`/${value}`);
  };

  const renderFranchiseOptions = () => {
    if (userData.loading) return null;
    if (userData.error) return null;

    return userData.currentUser.franchiseMemberships.map(fm => (
      <PopoverContentItem key={fm.franchise.id} value={fm.franchise.slug}>
        {fm.franchise.name}
      </PopoverContentItem>
    ));
  };

  return (
    <Popover onSelection={handleSelection}>
      <StyledPopoverTrigger aria-label="Panel Switcher">
        <Switch>
          <Route path="/admin" render={() => "Admin"} />
          <Route
            path="/:franchiseSlug"
            render={() =>
              (!franchiseData.loading &&
                !franchiseData.error &&
                franchiseData.franchiseBySlug &&
                franchiseData.franchiseBySlug.name) ||
              "Franchise"
            }
          />
        </Switch>
        <SwitcherLabel>Switch Location</SwitcherLabel>
        <StyledIcon icon={CODE} />
      </StyledPopoverTrigger>
      <PopoverContent
        style={{ marginLeft: 4 }}
        attachment="left"
        position="above"
      >
        {hasAdminAccess && (
          <PopoverContentItem value="admin">Admin</PopoverContentItem>
        )}
        {renderFranchiseOptions()}
      </PopoverContent>
    </Popover>
  );
};

const AccountSwitcherUserQuery = gql`
  query AccountSwitcherUserQuery {
    currentUser {
      id
      email
      name
      role
      franchiseMemberships {
        franchise {
          id
          name
          slug
        }
      }
    }
  }
`;

const AccountSwitcherFranchiseQuery = gql`
  query AccountSwitcherFranchiseQuery($slug: String!) {
    franchiseBySlug(slug: $slug) {
      id
      name
      slug
    }
  }
`;

const enhance = compose(
  withRouter,
  graphql(AccountSwitcherUserQuery, {
    name: "userData"
  }),
  graphql(AccountSwitcherFranchiseQuery, {
    name: "franchiseData",
    options: ({ match: { params: { franchiseSlug } } }) => ({
      variables: { slug: franchiseSlug }
    }),
    skip: ({ match: { params: { franchiseSlug } } }) => !franchiseSlug
  })
);

export default enhance(AccountSwitcher);



// WEBPACK FOOTER //
// ./src/components/sidebar/AccountSwitcher.js